import PadraoModel from 'src/core/model/PadraoModel.js'

export default class OlxCorModel extends PadraoModel {
  recurso = 'olx/cores';
  microServico = 'automotor';
  include = null;
  searchFixo = null;
  nome = 'Cores Olx';

  colunasGrid = [
  ];

  form = {
    id: null,
    nome: null
  };

  constructor () {
    super()
    this.formLimpo = Object.assign({}, this.form)
  }
}
